import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import App from "./App";

import { projectId } from "./utils/config";

import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/react'
import { configureChains, createConfig, WagmiConfig } from 'wagmi'
import { arbitrum, mainnet, polygon, avalanche, bsc,goerli } from 'wagmi/chains'

const chains = [arbitrum, mainnet, polygon,  avalanche, bsc, goerli]

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient,
});
const ethereumClient = new EthereumClient(wagmiConfig, chains);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <WagmiConfig config={wagmiConfig}>
    <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </WagmiConfig>
);
